module.exports = __webpack_public_path__ + "static/img/redbagbgmodal.05df2a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fission/redbagbgmodal.png
// module id = lgi2
// module chunks = 212